export default __webpack_public_path__ + "static/media/Snd_s2.194bb352.mp3";